export default "__VITE_ASSET__1d6493e3__"